import React from 'react';
import { SubTitleTab, TitleTab } from '../../../../../../component/page-components';
import { Col, Input, Row } from 'antd';

const OrderSpekOwned = ({ form }) => {
  return (
    <div className="columns">
      <TitleTab title="Order Specification" />

      <Row>
        <Col span={12} className="pr-2 ">
          <div className='container-field'>
            <SubTitleTab title="Max Unit" />
            <Input
              size='large'
              disabled
              value={form?.max_order_unit}
            />
          </div>
        </Col>
        <Col span={12} >
          <div className="container-field">
            <SubTitleTab title="Min Unit" />
            <Input
              size="large"
              disabled
              value={form?.min_order_unit}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={12} className="pr-2 ">
          <div className="container-field">
            <SubTitleTab title="Max Weight" />
            <Input
              size='large'
              disabled
              value={form?.max_order_weight}
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="container-field">
            <SubTitleTab title="Min Weight" />
            <Input
              size="large"
              disabled
              value={form?.min_order_weight}
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={12} className="pr-2 ">
          <div className="container-field">
            <SubTitleTab title="Max Volume" />
            <Input
              size='large'
              disabled
              value={form?.max_order_volume}
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="container-field">
            <SubTitleTab title="Min Volume" />
            <Input
              size="large"
              disabled
              value={form?.min_order_volume}
            />
          </div>
        </Col>
      </Row>

      <div className="container-field">
        <SubTitleTab title="Fix Cost" />
        <Input
          addonBefore="IDR"
          size="large"
          value={form?.fixed_cost}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Variable Cost Per Km (Optional)" />
        <Input
          addonBefore="IDR"
          size="large"
          value={form?.variable_cost}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Transporter Time Cost (Optional)" />
        <Input
          addonBefore="IDR"
          size="large"
          value={form?.transporter_time_cost}
          disabled
        />
      </div>

      <div className="container-field">
        <SubTitleTab title="Waiting Time Cost (Optional)" />
        <Input
          addonBefore="IDR"
          size="large"
          value={form?.waiting_time_cost}
          disabled
        />
      </div>
    </div>
  );
}

export default OrderSpekOwned;